export default Object.freeze({
  REGISTER_NEW_TICKET: 1001,
  CALL_TICKET: 1002,
  CALL_AGAIN_TICKET: 1003,
  REDIRECT_TICKET: 1004,
  CLOSE_TICKET : 1006,
  POSTPONE_TICKET: 1007,
  CANCEL_TICKET: 1008,
  OPERATOR_LOGIN: 2001,
  OPERATOR_LOGOUT: 2002,
  CHANGE_OPWORKSPACE_STATUS: 2003,
  RELOAD_DEVICE: 2004
});
